import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full py-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "t-22m text-wrh-blue-dark mb-6 mdlg:ml-2 xl:ml-3" }, "Please select at-least one home to perform this action", -1)
const _hoisted_3 = { class: "mdlg:flex flex-wrap w-full mdlg:flex-nowrap mdlg:scrollbar-thin mdlg:scrollbar-track-transparent mdlg:scrollbar-thumb-transparent mdlg:hover:wrh-scroll" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" No homes to display ")
const _hoisted_5 = ["onClick"]

import {
  ref, onBeforeMount, computed,
} from 'vue';
import { getAuth } from 'firebase/auth';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import Buyer from '@/util/homebuyer';
import { ReqHomesDocument } from '@/models';
import { Routes, StoreActions } from '@/constants';
import HomeCard from './component/HomeCard.vue';
import CardSkeleton from '@/components/skeleton/CardSkeleton.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const store = useStore();
const loading = ref(false);
const currentUserId = computed(() => store.getters.homebuyerId as string);
const homes = computed(() => store.getters.allHomes as ReqHomesDocument[]);
const selectedHome = computed(() => store.getters.selectedHome as ReqHomesDocument);

const fetchHomes = async (email:string) => {
  loading.value = true;
  if (!homes.value || !homes.value.length) {
    await Buyer.getBuyerDetails(email);
  }
  loading.value = false;
};

onBeforeMount(async () => {
  const user = getAuth().currentUser;
  if (user && user.email) {
    await fetchHomes(user.email);
  } else {
    router.push({ name: Routes.LOGIN });
  }
});

const homeSelected = async (home: ReqHomesDocument) => {
  await store.dispatch(StoreActions.RESET_HOME_DATA);
  Buyer.setSelectedHomeData(home);
  router.push({ name: Routes.DASHBOARD });
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      (loading.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(2, (i) => {
            return _createElementVNode("li", {
              key: i,
              class: "w-full flex-shrink-0 cursor-pointer md:w-[316px] mdlg:mx-2 xl:w-[345px] xl:mx-3 mb-4"
            }, [
              _createVNode(CardSkeleton)
            ])
          }), 64))
        : (!loading.value && !_unref(homes).length)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_4
            ], 64))
          : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(homes), (home, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          class: _normalizeClass(['w-full flex-shrink-0 cursor-pointer md:w-[316px] mdlg:mx-2 xl:w-[345px] xl:mx-3 mb-4', { 'hidden': loading.value}]),
          onClick: ($event: any) => (homeSelected(home))
        }, [
          _createVNode(HomeCard, {
            home: home,
            selectedHomeId: _unref(selectedHome).id
          }, null, 8, ["home", "selectedHomeId"])
        ], 10, _hoisted_5))
      }), 128))
    ])
  ]))
}
}

})